import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Config from '../../../config/config';
import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';

class WebhookPreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    this.api = { name: '', method: Const.True, access_token: '', fields: [], assigments: [] };
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
  }

  componentDidMount() {
    ThirdPartyAPI.get(this.id, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = api => {
    api.fields = JSON.parse(api.fields);
    api.assigments = JSON.parse(api.assigments);
    this.api = api;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    let param = this.api.method !== Const.True ? '?' : '{ ';
    for (let i = 0; i < this.api.fields.length; i++) {
      const key = this.api.fields[i].key;
      let field = `[${this.api.fields[i].field}]`;
      if (this.api.fields[i].field === 'phone') field = '"+[CountryCode]-[PhoneNo]"';
      if (this.api.method === Const.True) {
        param += `"${key}" : ${field}`;
        param += i !== this.api.fields.length - 1 ? ', ' : ' }';
      } else {
        param += `${key}=${field}`;
        param += i !== this.api.fields.length - 1 ? '&' : '';
      }
    }

    let assigments = this.api.assigments.map((assigment, i) => {
      if (!assigment.field) return null;
      let field = this.model.fields[assigment.field];
      let value = assigment.value;
      if (field !== undefined) {
        const isText = FieldController.showTextFilter(field.field_type, FieldController.Equals);
        if (!isText) {
          const options = FieldController.getOptions(field, assigment.field);
          const option = options.find(option => option.value === assigment.value);
          value = option !== undefined ? option.label : '';
        }
        field = field.label_name;
      } else if (assigment.field.includes(Const.Opt)) {
        const options = FieldController.getOptions(undefined, assigment.field);
        const option = options.find(option => option.value === assigment.value);
        value = option !== undefined ? option.label : '';
        field = assigment.field;
      } else field = assigment.field;
      return <tr key={`assign_${i}`}><td>{i + 1}</td><td>{field}</td><td>{value}</td></tr>;
    });

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row mb-6">
              <div className="col-md-6 pb-3"><h3>{this.api.name}</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered >
                  <thead>
                    <tr><th>Method</th><th>URL</th><th>Headers</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{this.api.method === Const.True ? 'POST' : 'GET'}</td>
                      <td>{`${Config.app.link}api/hit/${this.models.api_key}/${this.api.access_token}`
                        + `${this.api.method !== Const.True ? param : ''}`}</td>
                      <td>
                        Access-Control-Allow-Origin : *
                        <br />Content-Type : application/json
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>

            {this.api.method === Const.True &&
              <div className="row">
                <div className="col-md-6 pb-3"><h3>Fields</h3></div>
                <div className="col-md-12">
                  <Table className="table-th-color" bordered>
                    <thead><tr><th>Body</th></tr></thead>
                    <tbody>{param}</tbody>
                  </Table>
                </div>
              </div>
            }

            <div className="row">
              <div className="col-md-6 pb-3"><h3>Update CRM Field</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>Sr</th><th>CRM Field</th><th>Value</th></tr></thead>
                  <tbody>{assigments}</tbody>
                </Table>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(WebhookPreview);
